<script lang="ts">
    import { cx } from '$lib/utils/cx.js';
    import { getButtonMenuContext } from '$components/ButtonMenu/Context.js';
    import Spinner from '$components/Spinner/Spinner.svelte';
    import { fade } from 'svelte/transition';
    import { melt } from '@melt-ui/svelte';

    export let icon: string | null = null;
    export let suffixIcon: string | null = null;
    export let label: string = '';

    export let key: string;

    const { meltMenu, isLoading, allDisabled, onClick } = getButtonMenuContext();
    const {
        elements: { item },
    } = meltMenu;

    $: loading = $isLoading(key);
    $: disabled = $allDisabled;
    $: disabledAttr = disabled ? { 'data-disabled': true } : {};
</script>

{#key key}
    <li class="flex">
        <button
            use:melt={$item}
            on:m-click={() => onClick(key)}
            class={cx(
                'btn-reset flex-auto text-left px-8 py-3 font-normal font-gray-700 truncate bg-white focus:text-gray-800 hover:text-gray-800 focus:no-underline hover:no-underline focus:bg-gray-200 hover:bg-gray-200',
                disabled ? 'b:text-gray-400 b:cursor-not-allowed' : '',
            )}
            {disabled}
            {...disabledAttr}
        >
            <span class="flex items-center gap-4">
                {#if icon != null}
                    <i class={icon} aria-hidden={true} />
                {/if}
                <slot class="flex-auto">{label}</slot>
                {#if suffixIcon != null}
                    <i class={suffixIcon} aria-hidden={true} />
                {/if}
                {#if loading}
                    <Spinner
                        transitions={{ in: [fade, {}], out: [fade, {}] }}
                        size="xs"
                    />
                {/if}
            </span>
        </button>
    </li>
{/key}
